import React, { useState } from "react";
import { Button } from "@mui/material";

import SnackBar from "../components/snackbar";
import CardHeaderInfo from "../components/card_header";
import BreadCrumb from "../components/breadcrumb";
import CardsTable from "../components/cards_table/index";
import CardRechargeSection from "../components/card_recharge/card_recharge";

import { cards_data } from "../constants/table_data";

const CardCharge = () => {
  const [currentStep, setCurrentStep] = useState(0)
  const [chargeOption, setChargeOption] = useState('')
  const [selectedCards, setSelectedCards] = useState([])

  const [showMessage, setShowMessage] = useState(false)
  const openMessage = () => setShowMessage(true)
  const closeMessage = () => setShowMessage(false)

  const [openCharge, setCharge] = useState(false)
  const toggleCharge = (value) => setCharge(value)

  const onCancel = (e, reason) => {
    if (reason && reason === "backdropClick") return;
    toggleCharge(false);
  };

  const selectChargeOption = (option) => {
    setChargeOption(option)
    setCurrentStep(1)
  }

  const charge = () => {
    setSelectedCards([])
    setCurrentStep(0)
    openMessage();
  }

  return (
    <>
      <div className="section">
        <div className="pt-5 pb-3 px-4 px-xxl-5 ">
          <CardHeaderInfo />
        </div>
      </div>
      <div className="mb-n1 mb-sm-0">
        <BreadCrumb 
          active={currentStep}
          paths={[
            'Картууд сонгох', 'Төлбөр төлөлт'
          ]}
        />
      </div>
      <div className="section">
        <div className="p-0 p-sm-4 p-xxl-5">
          {
            currentStep === 0 && <>
              <CardsTable 
                tableData={cards_data}
                selectable={true} 
                setSelectedCards={setSelectedCards}
                selectedCards={selectedCards}
              />
              <div className="d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-sm-end mt-5">
                <Button
                  variant="outlined"
                  onClick={() => selectChargeOption('togrog')}
                  disabled={selectedCards < 1}
                  className="btn-bordered btn-bordered-white d-inline-flex w-100 w-sm-auto mx-4 mx-sm-2 mb-3 mb-sm-0"
                  startIcon={<i className='bx bx-plus'></i>}
                >
                  Төгрөгөөр цэнэглэх
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => selectChargeOption('litre')}
                  disabled={selectedCards < 1}
                  className="btn-bordered btn-bordered-white d-inline-flex w-100 w-sm-auto mx-4 mx-sm-0 mb-5 mb-sm-0"
                  startIcon={<i className='bx bx-plus'></i>}
                >
                  Литрээр цэнэглэх
                </Button>
              </div>
            </>
          }
          { currentStep === 1 && 
            <CardRechargeSection 
              charge={charge}
              chargeOption={chargeOption}
              openCharge={openCharge}
              onCancel={onCancel}
              toggleCharge={toggleCharge}
              cards={cards_data.filter(c => selectedCards.indexOf(c.cardNumber) >= 0)}/> 
          }
          {
            currentStep === 1 && <div className="d-flex d-lg-none my-4 justify-content-end">
              <Button
                onClick={() => toggleCharge(true)}
                className="bg-primary btn-bordered w-100 w-sm-auto px-9 mx-3 mx-sm-0"
                variant="contained"
                disableElevation
                endIcon={<i className='bx bx-right-arrow-alt'></i>}
              >
                <span>Үргэлжлүүлэх</span>
              </Button>
            </div> 
          }
        </div>
      </div>
      <SnackBar 
        showMessage={showMessage} 
        closeMessage={closeMessage}/>
    </>
  );
};

export default CardCharge;
